import React from 'react'

import style from './style.scss'

export default () => {
  return (
    <div className={`${style.loading}`}>
      <div className={`${style['loading__folding-cube']} ${style['loading__spinner']}`}>
        <div className={`${style.loading__cube1} ${style.loading__cube}`}> </div>
        <div className={`${style.loading__cube2} ${style.loading__cube}`}> </div>
        <div className={`${style.loading__cube4} ${style.loading__cube}`}> </div>
        <div className={`${style.loading__cube3} ${style.loading__cube}`}> </div>
      </div>
    </div>
  )
}